export default "__VITE_ASSET__3b47aacc__"